export default __webpack_public_path__ + "static/media/sidehustle.cd12c775.png";